import { render, staticRenderFns } from "./PinnedOrders.vue?vue&type=template&id=1ca9a111&"
import script from "./PinnedOrders.vue?vue&type=script&lang=js&"
export * from "./PinnedOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/PinnedOrders.vue
// module id = null
// module chunks = 